/**
 * PayPal/Zettle LIVE readiness (L-05): lectura del RETORNO de Zettle.
 *
 * Zettle redirige el navegador a la redirect_uri registrada (`/zettle-callback.html`) con `?code&state`
 * (developer.zettle.com/docs/api/oauth). Esa página estática solo mueve la query al hash del SPA:
 * `#integrations/zettle-callback?code=…&state=…`. Esta función decide qué trajo, sin efectos: la
 * pantalla hace el POST con la sesión y limpia la URL para que el code no quede a la vista.
 *
 * Cómo avisa Zettle una DENEGACIÓN no está documentado; se trata cualquier `error` como tal, sin
 * mostrar su texto crudo (se recorta y no se interpreta).
 */

export const ZETTLE_CALLBACK_HASH_PREFIX = 'integrations/zettle-callback';

export type ZettleCallbackResult =
  | { kind: 'none' }
  | { kind: 'authorized'; code: string; state: string }
  | { kind: 'denied'; error: string }
  | { kind: 'invalid' };

export function parseZettleCallbackHash(hash: string): ZettleCallbackResult {
  const clean = hash.replace(/^#/, '');
  if (!clean.startsWith(ZETTLE_CALLBACK_HASH_PREFIX)) return { kind: 'none' };
  const rest = clean.slice(ZETTLE_CALLBACK_HASH_PREFIX.length);
  if (rest !== '' && !rest.startsWith('?')) return { kind: 'none' };

  const params = new URLSearchParams(rest.slice(1));
  const error = params.get('error');
  if (error) return { kind: 'denied', error: error.replace(/[^A-Za-z0-9_.-]/g, '').slice(0, 64) || 'error' };

  const code = params.get('code')?.trim() ?? '';
  const state = params.get('state')?.trim() ?? '';
  if (!code || !state || code.length > 512 || state.length > 1024) return { kind: 'invalid' };
  return { kind: 'authorized', code, state };
}
